(function () {
  'use strict';

  angular.module('app').component('bookingItemEditCost', bookingItemEditCost());

  function bookingItemEditCost() {
    return {
      bindings: {
        bookingItem: '<',
        booking: '<',
        onBookingItemCostSaved: '&',
      },
      controller: BookingItemEditCostComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-edit-cost/booking-item-edit-cost.component.html',
    };
  }

  BookingItemEditCostComponent.$inject = ['TaxService', 'UtilService'];

  function BookingItemEditCostComponent(TaxService, UtilService) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.$onInit = function () {
      vm.item = angular.copy(vm.bookingItem);

      vm.netCost = vm.item.net_cost;
      vm.pickupCost = vm.item.pickup_cost;
      vm.dropoffCost = vm.item.dropoff_cost;

      vm.calculateTotalCost();
    };

    vm.calculateTotalCost = function () {
      vm.item.net_cost = vm.netCost !== undefined ? vm.netCost : 0;

      let productPurchaseTaxes = vm.item.purchase_taxes;

      let net_cost = vm.item.net_cost;
      let pickup_cost = vm.pickupCost || 0;
      let dropoff_cost = vm.dropoffCost || 0;
      let discount_cost = 0;
      let subtotal_cost = net_cost + pickup_cost + dropoff_cost - discount_cost;
      let tax_cost_percentage = TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);
      let tax_exoneration_cost_percentage =
        TaxService.getProductTaxesTotalExonerationPercentage(productPurchaseTaxes);
      //   let net_tax_cost_percentage = tax_cost_percentage - tax_exoneration_cost_percentage;

      vm.item.purchase_taxes = TaxService.setProductTaxesAmounts(
        subtotal_cost,
        productPurchaseTaxes
      );

      let tax_cost = TaxService.getProductTaxesTotalAmount(vm.item.purchase_taxes);
      let tax_exoneration_cost = TaxService.getProductTaxesTotalExonerationAmount(
        vm.item.sale_taxes
      );
      let net_tax_cost = tax_cost - tax_exoneration_cost;

      let total_cost = subtotal_cost + net_tax_cost;

      vm.item.net_cost = vm.UtilService.roundNum(net_cost);
      vm.item.pickup_cost = vm.UtilService.roundNum(pickup_cost);
      vm.item.dropoff_cost = vm.UtilService.roundNum(dropoff_cost);
      vm.item.discount_cost = vm.UtilService.roundNum(discount_cost);
      vm.item.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
      vm.item.tax_cost = vm.UtilService.roundNum(tax_cost);
      vm.item.tax_exoneration_cost = vm.UtilService.roundNum(tax_exoneration_cost);
      vm.item.net_tax_cost = vm.UtilService.roundNum(net_tax_cost);
      vm.item.total_cost = vm.UtilService.roundNum(total_cost);

      let transactionTaxes = vm.item.sale_taxes.concat(vm.item.purchase_taxes);

      if (transactionTaxes.length > 0) {
        vm.item.transaction_taxes = transactionTaxes;
      }
    };

    vm.updateBookingItemCost = function (isFormValid) {
      if (!isFormValid || vm.item.total_cost < vm.item.discount_cost) return;

      vm.item.is_custom_cost = true;

      // console.log(vm.item);
      // return;

      vm.onBookingItemCostSaved({ $bookingItem: vm.item });
    };
  }
})();
